<template>
  <v-flex xs12 md6 xl4>
    <page-toolbar>
      <summary-toolbar @change="onChange" :report-type="reportType" v-slot="slotProps">
        <kendo-button type="button" title="Export to Excel" @click="exportToExcel">
          <i class="k-icon k-i-excel"></i>
        </kendo-button>
      </summary-toolbar>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 160px)"
      ref="rollSummaryGrid"
      v-on:databound="onGridDataBound"
      :autoBind="false"
      :data-source="this.dataSource"
      :editable="{mode: 'inline'}"
      :filterable="false"
      :sortable="false"
      :pageable="false"
      :columns="columns"
      :detailInit="detailInit"
    >
    </kendo-grid>
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import PageToolbar from '@/components/PageToolbar'
import SummaryToolbar from '@/components/Report/SummaryToolbar'

export default {
  name: 'RollSummary',
  components: {
    PageToolbar,
    SummaryToolbar,
  },
  methods: {
    onGridDataBound(e) {
      var gridData = e.sender.dataSource.view()
      var grid = this.$refs.rollSummaryGrid.kendoWidget()
      gridData.forEach(function(dataItem) {
        var row = grid.table.find("tr[data-uid='" + dataItem.uid + "']")
        if (dataItem.rowType == 'blue') {
          row.addClass('blueRow')
        } else {
          if (dataItem.rowType == 'bold') {
            row.addClass('boldRow')
          }
        }
      })
    },
    onChange(e) {
      this.parameters = e
      var grid = this.$refs.rollSummaryGrid.kendoWidget()
      grid.dataSource.read()
    },
    exportToExcel() {
      const exportUrl = '/api/heroux/RollSummaryReport/exportToExcel'
      location.href = `${exportUrl}?clientId=${this.clientId}&fsYear=${
        this.parameters.fsYear
      }&quarter=${this.parameters.quarter}&divisions=${this.parameters.divisions}&t=${
        this.tokenString
      }`
    },
    detailInit(e) {
      const $container = kendo.jQuery("<div id='detailGrid'/>")
      kendo.ui.progress($container, true)
      const rowId = e.data.rowId
      const columns = this.columns

      $container.appendTo(e.detailCell).kendoGrid({
        columns: columns,
        dataBound: () => kendo.ui.progress($container, false),
        dataSource: {
          type: 'aspnetmvc-ajax',
          schema: {
            errors: 'errors',
            total: 'total',
            data: 'data',
          },
          transport: {
            read: {
              type: 'GET',
              url: '/api/heroux/RollSummaryReport/getData',
              data: () => ({
                clientId: this.clientId,
                fsYear: this.parameters.fsYear,
                quarter: this.parameters.quarter,
                divisions: this.parameters.divisions,
                ccyPairId: this.parameters.ccyPairId,
                rowId: rowId,
              }),
              dataType: 'json',
            },
          },
        },
      })
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    isMasterClient() {
      return this.clientId == 0
    },
    columns() {
      return [
        {
          field: 'rowDescription',
          title: 'FFEC',
          width: 225,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'fairValue',
          title: 'Fair Value',
          width: 80,
          attributes: {style: 'text-align: right;'},
          format: this.numericFormat,
        },
        {
          field: 'incomeTaxes',
          title: 'Income Taxes',
          width: 80,
          attributes: {style: 'text-align: right;'},
          format: this.numericFormat,
        },
        {
          field: 'netFairValue',
          title: 'Net Fair Value',
          width: 80,
          attributes: {style: 'text-align: right;'},
          format: this.numericFormat,
        },
      ]
    },
    editable() {
      return this.role != 'Guest'
    },
  },
  data() {
    return {
      reportType: 2,
      numericFormat: '{0: #,;(#,);-}',
      parameters: null,
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/RollSummaryReport/getData',
            data: () => ({
              clientId: this.clientId,
              fsYear: this.parameters.fsYear,
              quarter: this.parameters.quarter,
              divisions: this.parameters.divisions,
              ccyPairId: this.parameters.ccyPairId,
            }),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'rowId',
            fields: {
              rowId: {type: 'number'},
              fsYear: {type: 'number'},
              quarterId: {type: 'number'},
              rowDescription: {type: 'string'},
              rowType: {type: 'string'},
              rowNumber: {type: 'number'},
              fairValue: {type: 'number'},
              incomeTaxes: {type: 'number'},
              netFairValue: {type: 'number'},
            },
          },
        },
      }),
    }
  },
}
</script>
